import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// import { ToastContainer } from 'react-toastify'; // Import ToastContainer
// import 'react-toastify/dist/ReactToastify.css'; // Import Toastify CSS

// Silence console logs in production
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>


     {/* Include ToastContainer here */}
     {/* <ToastContainer
      position="bottom-center" // Change position if needed
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    /> */}
    <App />
  </React.StrictMode>
);


